function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_17_242)",
  fill: "#12002D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.934 6.926H0V0h6.934v6.926zM.791 6.143h5.36V.783H.783l.008 5.36zM10 9.217h-.783V10H10v-.783zM8.45 10h-.764v-.783h.763V10zm-1.531 0h-.784v-.783h.784V10zm-1.531 0h-.784v-.783h.784V10zM3.857 9.217h-.783V10h.783v-.783z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.853 8.45H3.07v-.764h.783v.763zm0-1.531H3.07v-.784h.783v.784zm0-1.531H3.07v-.783h.783v.783zM3.857 3.074h-.783v.783h.783v-.783zM8.45 3.853h-.764V3.07h.763v.783zm-1.531 0h-.784V3.07h.784v.783zm-1.531 0h-.784V3.07h.784v.783zM10 3.074h-.783v.783H10v-.783zM10 8.45h-.783v-.764H10v.763zm0-1.531h-.783v-.784H10v.784zm0-1.531h-.783v-.783H10v.783z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_17_242"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h10v10H0z"
})))));